import React from 'react'

import styles from './styles.module.scss'

const Loading = props => {

  return (
    <div className={styles.mask}>
      <div className={styles.mask__container}>
        <p>{props.text || "Please wait"}</p>
        <div className={styles.loader__container}><div className={`${styles.loader} ${styles.centerLoader}`}><span></span></div></div>
      </div>
    </div>
  )
}

export default Loading